import React from 'react';
const ArticleDetailComponent = (props) => {
    let articleDetail = props.articleDetail;
    return (
        <div >
            {articleDetail && articleDetail.data && articleDetail.data.article &&  Object.entries(articleDetail.data.article).length > 0 ?

                <div className="text-left">

                    <h3 className="mt-4 mb-3 text-left page-title">
                        <span dangerouslySetInnerHTML={{ __html: articleDetail.data.article.title }}></span>
                    </h3>
                    <h4 className="sub-title"> ID: {articleDetail.data.article.id}</h4>

                    <div className="text-justify article-body mb-5 mt-4">
                        <span dangerouslySetInnerHTML={{ __html: articleDetail.data.article.content }}></span></div>
                </div>
                : '' }
        </div>
    );
};
export default ArticleDetailComponent;